export enum PlanningBoardGroupRowType {
  Project = 'projectId',
  Department = 'departmentId',
  Resource = 'resourceId',
  Class = 'classId'
}
